'use strict';

module.exports = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.prototype.finally` requires a global `Promise` be available.');
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/promise.prototype.finally/requirePromise.js
// module id = 179
// module chunks = 7